import { _ } from '@splunk/ui-utils/i18n';
import MissingValueSkipped from '@splunk/react-icons/enterprise/MissingValueSkipped';
import MissingValueZero from '@splunk/react-icons/enterprise/MissingValueZero';
import MissingValueJoin from '@splunk/react-icons/enterprise/MissingValueJoin';
import AxesConfig from '../../common/editorConfig/Axes';
import LegendConfig from '../../common/editorConfig/Legend';

const editorConfig = [
    {
        label: _('General'),
        layout: [
            [
                {
                    label: _('Null Values'),
                    option: 'chart.nullValueMode',
                    editor: 'editor.radioBar',
                    editorProps: {
                        values: [
                            { icon: MissingValueSkipped, label: _('Gaps'), value: 'gaps' },
                            { icon: MissingValueZero, label: _('Zero'), value: 'zero' },
                            { icon: MissingValueJoin, label: _('Connect'), value: 'connect' },
                        ],
                    },
                },
            ],
            [
                {
                    label: _('Show Data Values'),
                    option: 'chart.showDataLabels',
                    editor: 'editor.radioBar',
                    editorProps: {
                        values: [
                            { label: _('Off'), value: 'none' },
                            { label: _('On'), value: 'all' },
                            { label: _('Min/Max'), value: 'minmax' },
                        ],
                    },
                },
            ],
        ],
    },
    AxesConfig,
    LegendConfig,
];

export default editorConfig;
